<section class="container section-table py-5">
  <table mat-table [dataSource]="dataSource" class="table-style themeHeaderTable">
    <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="tire_size">
      <th mat-header-cell *matHeaderCellDef>ขอบ</th>
      <td mat-cell *matCellDef="let element">{{ element.tire_size }}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="dimension">
      <th mat-header-cell *matHeaderCellDef>ขนาดยาง</th>
      <td mat-cell *matCellDef="let element">{{ element.dimension }}</td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="load_index">
      <th mat-header-cell *matHeaderCellDef>ขีดจำการรับน้ำหนักต่อล้อ</th>
      <td mat-cell *matCellDef="let element">{{ element.load_index }}</td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="speed_rating">
      <th mat-header-cell *matHeaderCellDef>ขีดจำกัดความเร็วสูงสุด</th>
      <td mat-cell *matCellDef="let element">{{ element.speed_rating }}</td>
    </ng-container>

    <!-- Side Wall  -->
    <ng-container matColumnDef="sidewall">
      <th mat-header-cell *matHeaderCellDef>ตัวหนังสือบนแก้มยาง</th>
      <td mat-cell *matCellDef="let element">{{ element.sidewall }}</td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef>ราคาเส้นละ (บาท)</th>
      <td mat-cell *matCellDef="let element">{{ element.price | number : '1.0-0' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <button class="themeModelDetailButton" mat-flat-button (click)="clickPopup()">
    <span class="xl-mr-l-1">เลือกขนาดยาง</span>
  </button>
</section>
